var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useEffect, useState } from "react";
import { ListApprovals } from "../Approvals/ListApprovals";
import { useDataProvider, useRecordContext } from "react-admin";
import { decisionDetails } from "../Approvals/approvalReview";
import { ViewApproval } from "../Approvals/ViewApproval";
import { ApprovalMatrix } from "../Approvals/ApprovalMatrix";
import { useElectionEventTallyStore } from "@/providers/ElectionEventTallyProvider";
var ViewMode;
(function (ViewMode) {
    ViewMode[ViewMode["View"] = 0] = "View";
    ViewMode[ViewMode["List"] = 1] = "List";
    ViewMode[ViewMode["Matrix"] = 2] = "Matrix";
})(ViewMode || (ViewMode = {}));
export var EditElectionEventApprovals = function (_a) {
    var electionEventId = _a.electionEventId, electionId = _a.electionId, showList = _a.showList;
    var electionEventRecord = useRecordContext();
    var _b = useState(ViewMode.List), viewMode = _b[0], setViewMode = _b[1];
    var _c = useState(null), currApprovalId = _c[0], setCurrApprovalId = _c[1];
    // The rule that decided the enrollment the matrix was opened from.
    var _d = useState(), cameFrom = _d[0], setCameFrom = _d[1];
    var dataProvider = useDataProvider();
    var _e = useElectionEventTallyStore(), taskId = _e.taskId, setTaskId = _e.setTaskId;
    var onViewApproval = function (id) {
        setViewMode(ViewMode.View);
        setCurrApprovalId(id);
        setTaskId(id);
    };
    var onViewList = function () {
        setViewMode(ViewMode.List);
        // Back in the queue no enrollment is open: the matrix returns here, not to the last review.
        setCurrApprovalId(null);
    };
    var onViewMatrix = function (decided) {
        setCameFrom(decided);
        setViewMode(ViewMode.Matrix);
    };
    var onViewRule = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var data, decision;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dataProvider.getOne("sequent_backend_applications", { id: id })];
                case 1:
                    data = (_a.sent()).data;
                    decision = decisionDetails(data);
                    onViewMatrix(decision ? { version: decision.matrixVersion, rule: decision.rule } : undefined);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (showList) {
            setViewMode(ViewMode.List);
            setCurrApprovalId(null);
        }
    }, [showList]);
    useEffect(function () {
        if (!taskId) {
            setViewMode(ViewMode.List);
            setCurrApprovalId(null);
        }
    }, [taskId]);
    return (_jsx(_Fragment, { children: viewMode === ViewMode.List ? (_jsx(ListApprovals, { electionEventId: electionEventId, electionId: electionId, onViewApproval: onViewApproval, onViewMatrix: function () { return onViewMatrix(); }, onViewRule: onViewRule, electionEventRecord: electionEventRecord })) : viewMode === ViewMode.Matrix ? (_jsx(ApprovalMatrix, { electionEventId: electionEventId, goBack: currApprovalId && cameFrom ? function () { return setViewMode(ViewMode.View); } : onViewList, cameFrom: cameFrom })) : (_jsx(ViewApproval, { electionEventId: electionEventId, electionId: electionId, currApprovalId: currApprovalId, electionEventRecord: electionEventRecord, goBack: onViewList, onViewRule: onViewMatrix })) }));
};
